/**
 * PENDÊNCIAS OPERACIONAIS
 * Placeholder — regra de negócio futura
 */
import React from 'react';
import { Flag } from 'lucide-react';

export default function PendenciasCard() {
  const pendencias = [
    { label: 'Documentos pendentes',  valor: 0, icone: '📄' },
    { label: 'Informações do imóvel', valor: 0, icone: '🏠' },
    { label: 'Vistorias pendentes',   valor: 0, icone: '📍' },
    { label: 'Validações',            valor: 0, icone: '✓'  },
    { label: 'Revisões necessárias',  valor: 0, icone: '👁️' },
  ];

  const total = pendencias.reduce((a, p) => a + p.valor, 0);

  return (
    <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6">

      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-lg bg-orange-500/10 border border-orange-500/20 flex items-center justify-center">
          <Flag size={14} className="text-orange-400" />
        </div>
        <div>
          <h3 className="text-[10px] font-bold text-orange-400 uppercase tracking-[0.2em]">
            Pendências Operacionais
          </h3>
          <p className="text-[9px] text-slate-500 uppercase tracking-wider mt-0.5">
            {total} pendência{total !== 1 ? 's' : ''}
          </p>
        </div>
      </div>

      <div className="space-y-2">
        {pendencias.map((p, i) => (
          <button
            key={i}
            className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-white/[0.03] transition-all group"
          >
            <div className="flex items-center gap-3">
              <span className="text-base">{p.icone}</span>
              <span className="text-slate-400 text-xs">{p.label}</span>
            </div>
            <span className={`font-bold text-sm ${p.valor > 0 ? 'text-white' : 'text-slate-600'}`}>
              {p.valor}
            </span>
          </button>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-white/[0.06]">
        <p className="text-[9px] text-slate-500 uppercase tracking-widest text-center">
          Regras de negócio em implementação
        </p>
      </div>

    </div>
  );
}